import { isArray } from 'lodash';

export const getErrors = (errors: { [key: string]: string[] | string }) =>
  Object.values(errors)
    .map((error) => (isArray(error) ? error.join('\n') : error))
    .join('\n');
